import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { type FormValues } from "@userFrontend/features/promotion/components/Assessment/schema";
import { Presentation } from "./Presentation";

export const PersonalSalesField: FC = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();

  const value = watch("personalSales");

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue("personalSales", e.target.value, {
      shouldDirty: true,
    });
  };

  return (
    <Presentation value={value} onChange={onChange} errorMessage={errors.personalSales?.message} />
  );
};
